import * as React from 'react';
import { getCourierPartners } from "src/api/shipmentExecution";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect } from "src/hooks/form/useSelect";
import { CourierPartner } from 'src/Library/Types';
import useApi from '../useApi';

const useCourierPartner = <T>(
  props: useFieldProps<T>,
  ) => {
  const partners = useApi(getCourierPartners);
  const field = useSelect(
    props,
    getCourierPartners,
    (data) => data?.map(dataMap) || [],
  );

  React.useEffect(() => {
    if (partners.status === 'FINISHED') {
      field.setOptions(partners.data?.map(dataMap) || []);
    }
  }, [partners.status]);

  const dataMap = (item: CourierPartner) => ({
    key: item.code,
    label: item.name,
    ...item,
  });

  return {
    ...field,
  };
};

export default useCourierPartner;
